import routes from '@/constants/routes';
import type { SidebarState } from '@/types';
import { produce } from 'immer';

const initialState = {
	isExpand: true,
	isHydrated: false,
	lastSelectedMenuItem: routes['/'],
};

export const createSidebarStore = (
	set: (
		state:
			| Partial<SidebarState>
			| ((state: SidebarState) => Partial<SidebarState>),
	) => void,
): SidebarState => ({
	...initialState,
	resetState: () => set(initialState),
	setIsHydrated: (isHydrated: boolean) => set({ isHydrated }),
	setIsExpand: (isExpand: boolean) => {
		set(
			produce((state: SidebarState) => {
				state.isExpand = isExpand;
			}),
		);
	},
	setLastSelectedMenuItem: (lastSelectedMenuItem: string) => {
		set(
			produce((state: SidebarState) => {
				state.lastSelectedMenuItem = lastSelectedMenuItem;
			}),
		);
	},
});
